module.exports = __webpack_public_path__ + "static/macos-05f81c969107defd81771bb8ec09a69d.png";